<mat-sidenav-container class="sidenav-container">

  <mat-sidenav #drawer class="sidenav" fixedInViewport [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'" [opened]="(isHandset$ | async) === false">
    <mat-toolbar style="color: rgb(255, 255, 255);text-align: center;">Menu</mat-toolbar>


    <div>
      <button class="button-especial" routerLink="paginas/reportes_control">
        <span>Reportes Contol</span>
      </button>
      <button class="button-especial" routerLink="paginas/checks" *ngIf="isAdmin">
        <span>Checks</span>
      </button>
      <button class="button-especial" routerLink="paginas/clientes" *ngIf="isAdmin">
        <span>Clientes</span>
      </button>
      <button class="button-especial" routerLink="paginas/control-banda" *ngIf="isAdmin">
        <span>Control banda</span>
      </button>
      <button class="button-especial" routerLink="paginas/control-empaque" *ngIf="isAdmin">
        <span>Control empaque</span>
      </button>
      <button class="button-especial" routerLink="paginas/control-ramo" *ngIf="isAdmin">
        <span>Control hidratación</span>
      </button>
      <button class="button-especial" routerLink="paginas/control-linea" *ngIf="isAdmin">
        <span>Control linea</span>
      </button>
      <button class="button-especial" routerLink="paginas/falencia-empaque" *ngIf="isAdmin">
        <span>Falencias empaque</span>
      </button>
      <button class="button-especial" routerLink="paginas/mesa" *ngIf="isAdmin">
        <span>Códigos operario</span>
      </button>
      <button class="button-especial" routerLink="paginas/mesa-empaque" *ngIf="isAdmin">
        <span>Mesas empaque</span>
      </button>
      <button class="button-especial" routerLink="paginas/linea" *ngIf="isAdmin">
        <span>Bandas</span>
      </button>
      <button class="button-especial" routerLink="paginas/especie" *ngIf="isAdmin">
        <span>Especie</span>
      </button>
      <button class="button-especial" routerLink="paginas/falencia-ramo" *ngIf="isAdmin">
        <span>Falencias ramo</span>
      </button>
      <button class="button-especial" routerLink="paginas/modulo" *ngIf="isAdmin">
        <span>Módulo</span>
      </button>
      <button class="button-especial" routerLink="paginas/postcosecha" *ngIf="isAdmin">
        <span>Postcosecha</span>
      </button>
      <button class="button-especial" routerLink="paginas/producto" *ngIf="isAdmin">
        <span>Producto</span>
      </button>
      <button class="button-especial" routerLink="paginas/supervisor" *ngIf="isAdmin">
        <span>Supervisor</span>
      </button>
      <button class="button-especial" routerLink="paginas/usuario" *ngIf="isAdmin">
        <span>Usuarios</span>
      </button>
    </div>
    <mat-nav-list style="background-color: rgba(255, 255, 255, 0.342);margin: 30px;border-radius: 18px;">
      <a mat-list-item (click)="logOut($event)" style="text-align: center;"><mat-icon>logout</mat-icon>Salir</a>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content>
    <mat-toolbar *ngIf="isLogin | async" color="primary" style="background-color: black; color: white">
      <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()">
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
      <span>High Control Group</span>
    </mat-toolbar>
    <div>
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
